import { threeDStudioStore } from 'Pods/ThreeDStudio/Store/index'

import { applyAllOf } from './applyAllOf'
import { buildInitialParams } from './buildInitialParams'
import { collectAllowedKeys } from './collectAllowedKeys'

export const buildGeneratePayload = (settingsKey, schema, additionalPayloadData) => {
  if (!schema) {
    throw new Error('No model schema found')
  }

  const state = threeDStudioStore.getState()
  const modelId = schema.model_id
  const inputSchema = schema.input_schema || {}
  const properties = inputSchema.properties || {}
  const topLevelRequired = inputSchema.required || []
  const allOf = inputSchema.allOf || []

  const allowedKeys = collectAllowedKeys(inputSchema)
  const initialParams = buildInitialParams(properties, settingsKey, state, topLevelRequired, allowedKeys)
  const canonicalParams = applyAllOf(initialParams, allOf, properties)

  const filteredCanonicalParams = Object.fromEntries(
    Object.entries(canonicalParams).filter(([key]) => allowedKeys.has(key)),
  )

  if (schema.keyToConvert) {
    schema.keyToConvert.forEach(({ from, to }) => {
      if (filteredCanonicalParams[from] === undefined || filteredCanonicalParams[from] === null) {
        return
      }

      filteredCanonicalParams[to] = filteredCanonicalParams[from]
      delete filteredCanonicalParams[from]
    })
  }

  return {
    data: {
      model_id: modelId,
      run_type: 'model_generation',
      ...additionalPayloadData,
      canonical_params: filteredCanonicalParams,
    },
  }
}
